import { jwtDecode } from 'jwt-decode';

export function redirectBasedOnRole(token: string): void {
  try {
    const decoded = jwtDecode<{ isadmin: boolean }>(token);
    
    if (decoded.isadmin.toString() == "false") {
      window.location.href = '/chat';
    } else {
      window.location.href = '/portal/home';
    }
  } catch (error) {
    console.error('Invalid token:', error);
    window.location.href = '/login';
  }
}



export interface DecodedUser {
  name: string;
  useremail: string;
  isadmin: boolean;
  sub:string;
}

export function getUserInfo(token: string): DecodedUser | null {
  try {
    const decoded = jwtDecode<DecodedUser>(token);
    return decoded;
  } catch (error) {
    console.error('Invalid token:', error);
    return null;
  }
}